import { PLANNING_MEETING_FORM_VERSION } from '../constants/general';

export const getTotalPlansSelected = (form) => {
  const planKeys =
    form.version === PLANNING_MEETING_FORM_VERSION
      ? ['plans2YearCollege', 'plans4YearCollege', 'plansOther', 'plansMilitary', 'plansWorkforce']
      : ['plansCommunityCollege', 'plansJobCorps', 'plansVocationalTraining', 'plans4YearCollege', 'plansOther', 'plansMilitary', 'plansWorkforce'];
  return planKeys.reduce((total, key) => total + (form[key] ? 1 : 0), 0);
};
